import registerSchema, { registerInvitationSchema } from './Register.schema';
import { UserRegistrationType } from '@/services/register.types';

export const getRegisterSchema = (registrationType: UserRegistrationType) => {
  return registrationType === UserRegistrationType.INVITATION
    ? registerInvitationSchema()
    : registerSchema();
};
